module.exports = "https://static.wanderu.com/ui-react/_next/static/media/google-store.04d46ab8.png";